export default __webpack_public_path__ + "fb6d41e4ab4b7a2fa6176dc3e1a54d92.jpg";